<template>
  <c-container form>
    <component :is="component"/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'

import CSBPayment from './CSBPayment'

export default {
  name: 'NewCard',
  mixins: [
    page('クレジットカードを登録')
  ],
  computed: {
    component () {
      const payapi = this.getters['org/paymentApi']
      if (!payapi) {
        throw new Error('Undefined paymentApi')
      }
      if (!payapi.provider) {
        throw new Error('Undefined paymentApi.provider')
      }

      return CSBPayment
    }
  }
}
</script>
